/**
 * Supported Decision enums
 */
export enum Decision {
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  WITHDRAWN = 'Withdrawn',
  RUW = 'RUW',
  INELIGIBLE = 'Ineligible',
  RESCINDED = 'Rescinded',
  WAIVED = 'Waived',
  POSTPONED = 'Postponed',
}

export enum DecisionFilterType {
  FINAL = 'final',
  ALL = 'all',
}

export enum DecisionType {
  AF = 'Applied For',
  ENGINE = 'Engine',
  FINAL = 'Final',
  RHO = 'Random Holdout',
  PIA = 'Post Issue Audit',
  AUDIT = 'Audit',
  INITIAL_AUDIT = 'Initial Audit',
  FINAL_AUDIT = 'Final Audit',
  LEGAL_CHECK = 'Legal check',
  REINSTATEMENT = 'Reinstatement',
  PRELIMINARY_FINAL = 'Preliminary Final',
  PRELIMINARY_PIA = 'Preliminary PIA',
  PLAN_F = 'PlanF',
}

export const CarrierDecisionType = [
  DecisionType.INITIAL_AUDIT,
  DecisionType.FINAL_AUDIT,
  DecisionType.LEGAL_CHECK,
];

export enum PA {
  PA100 = 100,
  PA150 = 150,
  PA175 = 175,
  PA200 = 200,
  PA225 = 225,
  PA250 = 250,
  PA275 = 275,
  PA300 = 300,
  PA325 = 325,
  PA350 = 350,
  PA375 = 375,
  PA400 = 400,
}

export enum DebitsValue {
  Debits_N50 = -50,
  Debits_N25 = -25,
  Debits_0 = 0,
  Debits_25 = 25,
  Debits_50 = 50,
  Debits_75 = 75,
  Debits_100 = 100,
  Debits_125 = 125,
  Debits_150 = 150,
  Debits_175 = 175,
  Debits_200 = 200,
  Debits_225 = 225,
  Debits_250 = 250,
}

export enum TobaccoClass {
  TOBACCO = 'Tobacco',
  NONTOBACCO = 'NonTobacco',
}

export enum RateClass {
  STANDARD = 'Standard',
  STANDARDPLUS = 'StandardPlus',
  PREFERRED = 'Preferred',
  PREFERREDPLUS = 'PreferredPlus',
}

export enum UpdatedRateClass {
  STANDARD = 'standard',
  STANDARD_PLUS = 'standard_plus',
  PREFERRED = 'preferred',
  PREFERRED_PLUS = 'preferred_plus',
}

export const DecisionSortOrder = {
  Declined: 0,
  RUW: 1,
  Approved: 2,
};

export const RateClassSortOrder = {
  [UpdatedRateClass.STANDARD]: 0,
  [UpdatedRateClass.STANDARD_PLUS]: 1,
  [UpdatedRateClass.PREFERRED]: 2,
  [UpdatedRateClass.PREFERRED_PLUS]: 3,
};

export function isDebitsAvailable(rateClass: string): boolean {
  switch (rateClass) {
    case RateClass.PREFERRED:
    case RateClass.PREFERREDPLUS:
    case RateClass.STANDARDPLUS:
      return false;
    default:
      return true;
  }
}

export const transformRateClass = (rateClass: RateClass) => {
  switch (rateClass) {
    case RateClass.PREFERREDPLUS:
      return 'Preferred Plus';
    case RateClass.STANDARDPLUS:
      return 'Standard Plus';
    default:
      return rateClass;
  }
};

export const transformTobaccoClass = (tobaccoClass: string) => {
  return tobaccoClass === 'NonTobacco' ? 'Non-Tobacco' : tobaccoClass;
};

export const RATE_CLASS_DISPLAY_TEXT: Record<UpdatedRateClass, string> = {
  [UpdatedRateClass.STANDARD]: 'Standard',
  [UpdatedRateClass.STANDARD_PLUS]: 'Standard Plus',
  [UpdatedRateClass.PREFERRED]: 'Preferred',
  [UpdatedRateClass.PREFERRED_PLUS]: 'Preferred Plus',
};

export const TOBACCO_CLASS_DISPLAY_TEXT: Record<TobaccoClass, string> = {
  [TobaccoClass.NONTOBACCO]: 'Non Tobacco',
  [TobaccoClass.TOBACCO]: 'Tobacco',
};
